// extracted by mini-css-extract-plugin
export var chevronIcon = "_cb-2";
export var teamName = "_cb-1";
export var teamSwitcherButton = "_cb-0";